<template>
    <div
        v-spinner="pageLoading"
        class="wxkf-config"
    >
        <v-spinner :opacity="0.5" />
        <v-status-bar
            v-if="!isBind"
            kind="alarm"
            size="medium"
        >
            <span>暂未开启使用微信客服，无法设置企业在微信上的对外形象。<a
                href="/mng/account/wework/wxkf"
                target="_blank"
            >开启微信客服接入</a></span>
        </v-status-bar>
        <v-status-bar
            v-if="!isInstall"
            kind="slight-warning"
            size="medium"
        >
            <span>暂未安装应用【{{ appName }}】，微信客服相关能力已失效，安装后可恢复使用。<a
                :href="installUrl"
                target="_blank"
            >去安装</a></span>
        </v-status-bar>
        <div
            :class="{ disabled: !(isBind && isInstall) }"
            class="wxkf-wrap"
        >
            <div class="preview">
                <div class="desc-item h5">
                    <div class="title">
                        移动端
                    </div>
                    <div class="show-content">
                        <v-icon
                            class="desc-item__preview"
                            name="mobile_wxkf"
                        />
                        <img
                            v-if="selectImg"
                            :src="selectImg"
                        >
                        <div
                            v-if="selectName"
                            class="kf-name"
                        >
                            {{ selectName }}
                        </div>
                    </div>
                </div>
                <div class="desc-item pc">
                    <div class="title">
                        电脑端
                    </div>
                    <div class="show-content">
                        <v-icon
                            class="desc-item__preview"
                            name="pc_wxkf"
                        />
                        <img
                            v-if="selectImg"
                            :src="selectImg"
                            class="contract-list-img"
                        >
                        <img
                            v-if="selectImg"
                            :src="selectImg"
                            class="wx-im-img"
                        >
                        <div
                            v-if="selectName"
                            class="kf-name"
                        >
                            {{ selectName }}<span class="comp-name">@{{ compName }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="setting">
                <div class="title">
                    客服形象
                </div>
                <div class="desc">
                    设置形象后可在不同微信接待组件中指定相应的客服形象
                    <a
                        href="/tp/wpaWx"
                        target="_blank"
                    >去设置接待组件</a>
                </div>
                <v-tip
                    ref="cannotadd"
                    placement="top"
                >
                    最多可创建{{ max }}个客服形象
                </v-tip>
                <div
                    key="disabledAdd"
                    v-if="disabledAdd"
                    v-tip:cannotadd
                    class="add-kf disabled-add"
                >
                    <v-icon
                        remot
                        name="basic_new_line"
                    />新增形象
                </div>
                <div
                    v-popconfirm:addKFDialog
                    v-else
                    class="add-kf"
                >
                    <v-icon
                        remot
                        name="basic_new_line"
                    />新增形象
                </div>
                <div class="list">
                    <wxkf-item
                        v-for="(kf, index) in kflist"
                        :key="kf.open_kfid"
                        :value="kf"
                        :selected="selectIndex === index"
                        :index="index"
                        :comp-name="compName"
                        :can-delete="canDelete"
                        @remove="remove"
                        @change="onChangeItem"
                        @mouseenter="onMouseenter"
                        @mouseleave="onMouseleave"
                    />
                    <v-pagination
                        @change="getList"
                        :total="total"
                        :count="count"
                        :index="index"
                        :count-options="[20, 40, 60]"
                    />
                </div>
                <v-popconfirm
                    ref="addKFDialog"
                    :use-arrow="false"
                    :loading="loading"
                    :gap="10"
                    @confirm="addKF"
                >
                    <wxkf-editor
                        ref="wxkfItemEditor"
                        :value="{}"
                    />
                    <span slot="confirm-text">保存</span>
                </v-popconfirm>
            </div>
        </div>
    </div>
</template>
<script>
import { Icon } from 'vhtml-ui';
import conf from 'src/pages/srv/wpa2/detail/conf.js';

import getBindInfo from '@/pages/mng/workWeixin/api/getBindInfo';
import getWxkfInstallInfo from '@/pages/mng/wework/api/getWxkfInstallInfo';
import WxkfItem from './wxkf-item';
import WxkfEditor from './wxkf-editor';
import wxkfmixins from './wxkfmixins';

const sprites = require.context('./assets/icons', true, /[^\.]+\.svg$/); // eslint-disable-line
Icon.addSprites(sprites);

export default {
    name: 'WxkfConfig',
    components: {
        WxkfItem,
        WxkfEditor,
    },
    mixins: [wxkfmixins],
    data() {
        return {
            kflist: [],
            compName: '乐悠悠旅行',
            pageLoading: true,
            isBind: 1, // 绑定状态，0:绑定，1:未绑定
            isInstall: 1,
            installUrl: '',
            // 需要安装的应用名称
            appName: '',
            selectIndex: -1,
            loading: false,
            total: 0,
            count: 20,
            index: 1,
            max: 5000,
        };
    },
    computed: {
        canDelete() {
            return this.kflist.length > 1;
        },
        disabledAdd() {
            return this.total >= this.max;
        },
        selectImg() {
            if (this.selectIndex > -1) {
                return this.kflist[this.selectIndex].origin_url;
            }
            return '';
        },
        selectName() {
            if (this.selectIndex > -1) {
                return this.kflist[this.selectIndex].name;
            }
            return '';
        },
    },
    created() {
        const { data = {} } = window.pageData || {};
        const { corpInfo = {} } = data || {};
        const isVerifiedWeChat = corpInfo.corp_type === 'verified';
        if (!isVerifiedWeChat) {
            this.max = 10;
        }
        getBindInfo()
            .then((res) => {
                const { isBind, bindInfo } = res || {};
                this.isBind = isBind;
                if (isBind) {
                    getWxkfInstallInfo().then((data) => {
                        const { isInstall, installUrl, name } = data || {};
                        this.isInstall = isInstall;
                        if (isInstall) {
                            this.compName = bindInfo.corp_name;
                            this.getList();
                        } else {
                            this.pageLoading = false;
                            this.installUrl = installUrl;
                            this.appName = name;
                            this.initNoData();
                        }
                    });
                } else {
                    this.pageLoading = false;
                    this.initNoData();
                }
            })
            .catch((err) => {
                this.$message.error(err || '获取绑定信息失败');
                this.pageLoading = false;
            });
    },
    methods: {
        initNoData() {
            // 头像地址是有框架机直出的数据staticRoot来进下判断的
            const imgurl = `${window.pageData.staticRoot + conf.wpaAvatarRoot}wxkf-1.png`;
            this.kflist = [{ name: '微信客服', origin_url: imgurl, avatar: imgurl, in_use: false }];
            this.select(0);
        },
        onMouseenter(index) {
            if (this.leaveTimer) {
                clearTimeout(this.leaveTimer);
                this.leaveTimer = null;
            }
            this.select(index);
        },
        select(index) {
            if (this.kflist.length > index) {
                this.selectIndex = index;
                this.$emit('select', this.kflist[index]);
            }
        },
        onMouseleave() {
            this.leaveTimer = setTimeout(() => {
                this.select(0);
                this.leaveTimer = null;
            }, 100);
        },
        getList(index = 1, count) {
            const params = {
                index,
                count: count || this.count,
            };
            this.index = index;
            this.pageLoading = true;
            this.$ajax.gatewayGet('/v1/kf/reception/receptionConf/wechatSvr/getWxAccountImage/list', { params }).then(
                (res) => {
                    this.pageLoading = false;
                    if (res.code === 0) {
                        this.kflist = res.data.account_list.map((item) => {
                            if (item.origin_url === '') {
                                item.origin_url = item.avatar;
                            }
                            return item;
                        });
                        this.select(0);
                        this.total = res.data.total || 0;
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (err) => {
                    this.pageLoading = false;
                    this.$message.error(err.msg);
                }
            );
        },
        addKF(e) {
            // 添加新头像
            e.preventDefault();
            this.$refs.wxkfItemEditor
                .validate()
                .then(data => data)
                .then((data) => {
                    this.loading = true;
                    this.uploadWx(data.originUrl)
                        .then((mediaId) => {
                            if (!mediaId) {
                                this.loading = false;
                                return;
                            }
                            this.$ajax
                                .gatewayPost('/v1/kf/reception/receptionConf/wechatSvr/wxAccountImage/add', {
                                    name: data.name,
                                    media_id: mediaId,
                                    origin_url: data.originUrl,
                                })
                                .then((res) => {
                                    this.loading = false;
                                    if (res.code === 0) {
                                        this.$message.success('新增客服成功');
                                        this.$refs.addKFDialog.hide();
                                        this.$refs.wxkfItemEditor.clear();
                                        this.pageLoading = true;
                                        this.getList();
                                    } else {
                                        this.$message.error(res.msg || '新增客服失败');
                                    }
                                })
                                .catch((error) => {
                                    this.loading = false;
                                    this.$message.error(error.msg || '新增客服失败');
                                });
                        })
                        .catch(() => {
                            this.loading = false;
                            this.$message.error('上传微信失败');
                        });
                })
                .catch((err) => {
                    if (err) this.$message.error(err);
                });
        },
        remove() {
            // this.kflist.splice(index, 1);
            // this.select(0);
            this.getList();
        },
        onChangeItem(index, data) {
            this.kflist.splice(index, 1, data);
            // 更新avatar
            // this.getList();
        },
    },
};
</script>
<style lang="less">
@import '~src/common/common.less';

.wxkf-config {
    .wxkf-wrap {
        display: flex;
        &.disabled .kfitem .v-icon {
            display: none;
        }
    }
    overflow: hidden;

    .v-status-bar {
        margin-top: 20px;
    }
    .add-kf {
        // margin-left: 10px;
        float: left;
        cursor: pointer;
        margin-top: 10px;
        & > span,
        &.disabled-add {
            opacity: 0.4;
            cursor: default;
        }
        width: 108px;
        height: 32px;
        border: 1px solid #4A70FF;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #4A70FF;
        font-size: 14px;
        svg{
            margin-right: 5px;
        }
    }
    .wxkf-wrap {
        &.disabled {
            .add-kf {
                display: none;
            }
        }
    }
    .preview,
    .setting {
        margin-top: 37px;
        &.unbind {
            opacity: 0.5;
            .add-kf {
                display: none;
            }
        }
    }
    .add-kf.disabled {
        opacity: 0.5;
    }
    .preview {
        width: 590px;
        flex-shrink: 0;
    }
    .setting {
        font-size: 16px;
        flex: 1 1 0;
        & > .title {
            font-size: 18px;
        }
        & > .desc {
            color: #a1abc2;
            font-size: 13px;
        }
    }
    .desc-item {
        position: relative;
        display: inline-block;
        vertical-align: top;
    }
    .list {
        margin-top: 60px;
        // width: 635px;
    }
    .show-content {
        margin-top: 20px;
        position: relative;
        img {
            position: absolute;
            width: 20px;
            height: 20px;
            border-radius: 2px;
        }
        .kf-name {
            position: absolute;
            font-size: 20px;
            width: 160px;
            left: -12px;
            transform: scale(0.5);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .pc {
        .kf-name {
            top: 5px;
            left: 128px;
            width: 490px;
            transform-origin: left;
        }
        .comp-name {
            padding-left: 5px;
            color: @AidOrg;
        }
        .desc-item__preview {
            display: block;
            width: 374px;
            height: 270px;
        }
        .contract-list-img {
            top: 98px;
            left: 42px;
        }
        .wx-im-img {
            top: 46px;
            left: 128px;
        }
    }
    .h5 {
        margin-right: 32px;
        .kf-name {
            top: 10px;
            text-align: center;
        }
        .desc-item__preview {
            display: block;
            width: 136px;
            height: 270px;
        }
        img {
            top: 55px;
            left: 10px;
        }
    }
}
</style>
